<template>
  <NuxtLayout name="default" mainClass="inside_main">
    <div class="landing_wrapper business">




      <div class="hero">
        <div class="container">
          <div class="section_title">
            <h1>
              <span> قارن و اختر الباقة الانسب لانطلاقتك </span>
            </h1>
            <div class="pp-switch large">
              <label :class="['toggler', isMonthly ? 'toggler--is-active' : '']" @click="setMonthly(true)">
                الشهرية
              </label>

              <div :class="['toggle', !isMonthly ? 'active' : '']">
                <input type="checkbox" id="switcher" class="check" :checked="!isMonthly" @click="toggleView" />
                <b class="b switch"></b>
              </div>

              <label :class="['toggler', !isMonthly ? 'toggler--is-active' : '']" @click="setMonthly(false)">
                السنوية
                <span class="percentge-dicount">وفر 16 % مع الباقات السنوية</span>
              </label>
            </div>
            <span class="percentge-dicount mobile">وفر 16 % مع الباقات السنوية</span>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="pricing__table" id="features">
          <div class="pt__title">
            <div class="pt__title__wrap">
              <div class="pt__row border-0 package-sub-title one">المميزات</div>
              <div class="pt__row"></div>
              <div class="pt__row">عدد تقييمات</div>
              <div class="pt__row">ارسال حملات الواتساب</div>
              <div class="pt__row">تقارير تفصيلية</div>
              <div class="pt__row">عدد فروع</div>
              <div class="pt__row">انشاء حسابات لفريق العمل</div>
              <div class="pt__row border-0">
                الحصول على التحديثات بشكل مجاني طوال فترة الاشتراك
              </div>



            </div>
          </div>
          <div class="pt__option">
            <div class="pt__option__mobile__nav">
              <button id="navBtnLeftFeatures" class="mobile__nav__btn" type="button" @click="slidePrevFeatures" :disabled="isFirstSlideFeatures"
                :class="{ disabled: isFirstSlideFeatures }">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.81934 11.9819H22.1534" stroke="currentColor" stroke-width="3" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M11.9863 22.1535L22.1522 11.9865L11.9863 1.81946" stroke="currentColor" stroke-width="3"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>

              <button id="navBtnRightFeatures" class="mobile__nav__btn" type="button" @click="slideNextFeatures" :disabled="isLastSlideFeatures"
                :class="{ disabled: isLastSlideFeatures }">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22.1538 11.9819H1.81972" stroke="currentColor" stroke-width="3" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M11.9863 22.1535L1.82043 11.9865L11.9863 1.81946" stroke="currentColor" stroke-width="3"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
            <div class="pt__option__slider swiper" id="featuresPricingTableSlider">
              <div class="swiper-wrapper">
                <div class="swiper-slide pt__option__item">
                  <div class="pt__item">
                    <div class="pt__item__wrap">
                      <div class="pt__row">المجانية</div>
                      <div class="pt__row package-sub-title">مجاناً</div>

                      <div class="pt__row">
                        10
                      </div>
                      <div class="pt__row">
                        <div class="package-check-icon b-x">
                          <i class="bx bx-x"></i>
                        </div>
                      </div>
                      <div class="pt__row">
                        <div class="package-check-icon b-x">
                          <i class="bx bx-x"></i>
                        </div>
                      </div>
                      <div class="pt__row">
                        <div class="package-check-icon b-x">
                          <i class="bx bx-x"></i>
                        </div>
                      </div>
                      <div class="pt__row">
                        1
                      </div>
                      <div class="pt__row">
                        <div class="package-check-icon b-x">
                          <i class="bx bx-x"></i>
                        </div>
                      </div>

                      <!-- <div class="pt__row">
                            <a href="javascript:void(0)" class="subscribe-btn">اشترك الان</a>
                      </div> -->

                    </div>
                  </div>
                </div>
                <div class="swiper-slide pt__option__item">
                  <div class="pt__item recommend">
                    <div class="pt__item__wrap">
                      <div class="pt__row">الاحترافية</div>
                     
                      <div class="pt__row">
                        <div class="pricing-header" :class="{ hide: !isMonthly }" id="monthly">
                          <p class="price-value">
                            <span>99</span>
                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 1124.14 1256.39" width="25">
                              <path class="cls-1"
                                d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z" />
                              <path class="cls-1"
                                d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.27-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-95.67,66.32-132.25,110.99v403.35l-132.25,28.11V0c-50.67,28.44-95.67,66.32-132.25,110.99v525.69l-295.91,62.88c-20.06,44.47-33.33,92.75-38.42,143.37l334.33-71.05v170.26l-358.3,76.14c-20.06,44.47-33.32,92.75-38.4,143.37l375.04-79.7c30.53-6.35,56.77-24.4,73.83-49.24l68.78-101.97v-.02c7.14-10.55,11.3-23.27,11.3-36.97v-149.98l132.25-28.11v270.4l424.53-90.28Z" />
                            </svg>

                            <span class="vat">
                              + VAT
                            </span>

                          </p>
                        </div>

                        <div class="pricing-header" :class="{ hide: isMonthly }" id="yearly">
                          <p class="price-value">
                            <span class="discountPriceYearly">
                              1200
                              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 1124.14 1256.39" width="15">
                              <path class="cls-1"
                                d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z" />
                              <path class="cls-1"
                                d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.27-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-95.67,66.32-132.25,110.99v403.35l-132.25,28.11V0c-50.67,28.44-95.67,66.32-132.25,110.99v525.69l-295.91,62.88c-20.06,44.47-33.33,92.75-38.42,143.37l334.33-71.05v170.26l-358.3,76.14c-20.06,44.47-33.32,92.75-38.4,143.37l375.04-79.7c30.53-6.35,56.77-24.4,73.83-49.24l68.78-101.97v-.02c7.14-10.55,11.3-23.27,11.3-36.97v-149.98l132.25-28.11v270.4l424.53-90.28Z" />
                            </svg>
                            </span>
                            <span>999</span>
                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 1124.14 1256.39" width="25">
                              <path class="cls-1"
                                d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z" />
                              <path class="cls-1"
                                d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.27-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-95.67,66.32-132.25,110.99v403.35l-132.25,28.11V0c-50.67,28.44-95.67,66.32-132.25,110.99v525.69l-295.91,62.88c-20.06,44.47-33.33,92.75-38.42,143.37l334.33-71.05v170.26l-358.3,76.14c-20.06,44.47-33.32,92.75-38.4,143.37l375.04-79.7c30.53-6.35,56.77-24.4,73.83-49.24l68.78-101.97v-.02c7.14-10.55,11.3-23.27,11.3-36.97v-149.98l132.25-28.11v270.4l424.53-90.28Z" />
                            </svg>
                            <span class="vat">
                              + VAT
                            </span>
                          </p>
                        </div>
                      </div>

                      <div class="pt__row">
                        <div class="package-check-icon b-check">
                          <i class="bx bx-check"></i>
                        </div>
                      </div>
                      <div class="pt__row">
                        <div class="package-check-icon b-check">
                          <i class="bx bx-check"></i>
                        </div>
                      </div>
                      <div class="pt__row">
                        <div class="package-check-icon b-check">
                          <i class="bx bx-check"></i>
                        </div>
                      </div>
                      <div class="pt__row">
                        10
                      </div>
                      <div class="pt__row">
                        10
                      </div>
                      <div class="pt__row">
                        <div class="package-check-icon b-check">
                          <i class="bx bx-check"></i>
                        </div>
                      </div>



                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        
        <div class="pricing__table">
          <div class="pt__title">
            <div class="pt__title__wrap">
           
              <div class="pt__row border-0 package-sub-title">
               الخدمات

              </div>
              <div class="pt__row">
                سهولة إدارة الخدمات ( إضافة، تعديل، حذف )


              </div>
<div class="pt__row">
                تحكم بفترات الحجز ( تحديد الأيام والساعات )


              </div>
              

              <div class="pt__row">
                عرض التقويم ( رؤية شاملة للحجوزات )

              </div>

              <div class="pt__row">
                خيارات دفع مرنة ( ابل باي ، مدى ، فيزا ، ماستركارد ، تمارا ، تابي )
              </div>

              <div class="pt__row">
                أسئلة مخصصة اضافية ( حقل نصي او طلب صورة او ملف ، حقل تاريخ )


              </div>

              <div class="pt__row">
                تسويات مالية سلسة (متابعة ومراجعة المستحقات )

              </div>

              



              <div class="pt__row border-0">
                إحصائيات وتقارير مفصلة (تتبع الأداء بسهولة)

              </div>

              

            </div>
          </div>
          <div class="pt__option">
            <div class="pt__option__mobile__nav">
              <button id="navBtnLeftServices" class="mobile__nav__btn" type="button" @click="slidePrevServices" :disabled="isFirstSlideServices"
                :class="{ disabled: isFirstSlideServices }">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.81934 11.9819H22.1534" stroke="currentColor" stroke-width="3" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M11.9863 22.1535L22.1522 11.9865L11.9863 1.81946" stroke="currentColor" stroke-width="3"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>

              <button id="navBtnRightServices" class="mobile__nav__btn" type="button" @click="slideNextServices" :disabled="isLastSlideServices"
                :class="{ disabled: isLastSlideServices }">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22.1538 11.9819H1.81972" stroke="currentColor" stroke-width="3" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M11.9863 22.1535L1.82043 11.9865L11.9863 1.81946" stroke="currentColor" stroke-width="3"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
            <div class="pt__option__slider swiper" id="servicesPricingTableSlider">
              <div class="swiper-wrapper">
                <div class="swiper-slide pt__option__item">
                  <div class="pt__item">
                    <div class="pt__item__wrap">
                      <div class="pt__row"></div>
                     
                      <!-- <div class="pt__row">
                            <a href="javascript:void(0)" class="subscribe-btn">اشترك الان</a>
                      </div> -->


                      <div class="pt__row">
                        <div class="package-check-icon b-x">
                          <i class="bx bx-x"></i>
                        </div>
                      </div>
                      <div class="pt__row">
                        <div class="package-check-icon b-x">
                          <i class="bx bx-x"></i>
                        </div>
                      </div>
                      <div class="pt__row">
                        <div class="package-check-icon b-x">
                          <i class="bx bx-x"></i>
                        </div>
                      </div>
                      <div class="pt__row">
                        <div class="package-check-icon b-x">
                          <i class="bx bx-x"></i>
                        </div>
                      </div>
                      <div class="pt__row">
                        <div class="package-check-icon b-x">
                          <i class="bx bx-x"></i>
                        </div>
                      </div>
                      <div class="pt__row">
                        <div class="package-check-icon b-x">
                          <i class="bx bx-x"></i>
                        </div>
                      </div>
                      <div class="pt__row">
                        <div class="package-check-icon b-x">
                          <i class="bx bx-x"></i>
                        </div>
                      </div>

                      

                    </div>
                  </div>
                </div>
                <div class="swiper-slide pt__option__item">
                  <div class="pt__item recommend">
                    <div class="pt__item__wrap">
                      <div class="pt__row"></div>
                     
                      <div class="pt__row">
                        <div class="package-check-icon b-check">
                          <i class="bx bx-check"></i>
                        </div>
                      </div>
                      <div class="pt__row">
                        <div class="package-check-icon b-check">
                          <i class="bx bx-check"></i>
                        </div>
                      </div>
                      <div class="pt__row">
                        <div class="package-check-icon b-check">
                          <i class="bx bx-check"></i>
                        </div>
                      </div>
                      <div class="pt__row">
                        <div class="package-check-icon b-check">
                          <i class="bx bx-check"></i>
                        </div>
                      </div>
                      <div class="pt__row">
                        <div class="package-check-icon b-check">
                          <i class="bx bx-check"></i>
                        </div>
                      </div>
                      <div class="pt__row">
                        <div class="package-check-icon b-check">
                          <i class="bx bx-check"></i>
                        </div>
                      </div>
                      <div class="pt__row">
                        <div class="package-check-icon b-check">
                          <i class="bx bx-check"></i>
                        </div>
                      </div>

                     

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>


      <div class="create-business">
        <div class="container">
          <div class="create-business-card">
            <div>
              <h2>امتلك موقعك الان</h2>
              <p>
                أنشئ موقعك الآن بأدوات مرنة و حلول متكاملة تساعدك في اتخاذ قرارات شراء مدروسة بناءً على آراء موثوقة
              </p>
            </div>
            <a href="https://business.reviewapp.sa/register" class="hero_btn btn-register" target="_blank"> ابدأ الآن
            </a>
          </div>
        </div>
      </div>

    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
// You can add stores or composables here if needed
// For example:
// import { useWebsiteStore } from '~/store/website'
// const websiteStore = useWebsiteStore()
import { onMounted, onBeforeUnmount, nextTick, ref } from "vue";
import Swiper from "swiper";
import "swiper/css";
import "swiper/css/navigation";

useHead({
  title: "الباقات",
  meta: [
    {
      property: "og:title",
      content: `للأعمال | رفيو المنصة الأولى في التقييم و معرفة تجارب الآخرين و الاستفادة منها`,
    },
    {
      property: "twitter:title",
      content: `للأعمال | رفيو المنصة الأولى في التقييم و معرفة تجارب الآخرين و الاستفادة منها`,
    },
  ],
});

let featuresSwiper: Swiper | null = null;
let servicesSwiper: Swiper | null = null;
let mediaQuery: MediaQueryList;
let init = false;

const isFirstSlideFeatures = ref(true);
const isLastSlideFeatures = ref(false);
const isFirstSlideServices = ref(true);
const isLastSlideServices = ref(false);

const slideNextFeatures = () => {
  if (featuresSwiper) {
    featuresSwiper.slideNext();
  }
};

const slidePrevFeatures = () => {
  if (featuresSwiper) {
    featuresSwiper.slidePrev();
  }
};

const slideNextServices = () => {
  if (servicesSwiper) {
    servicesSwiper.slideNext();
  }
};

const slidePrevServices = () => {
  if (servicesSwiper) {
    servicesSwiper.slidePrev();
  }
};

function updateNavigationStateFeatures() {
  if (featuresSwiper) {
    isFirstSlideFeatures.value = featuresSwiper.isBeginning;
    isLastSlideFeatures.value = featuresSwiper.isEnd;
  }
}

function updateNavigationStateServices() {
  if (servicesSwiper) {
    isFirstSlideServices.value = servicesSwiper.isBeginning;
    isLastSlideServices.value = servicesSwiper.isEnd;
  }
}

function initSwipers() {
  const isMobile = window.matchMedia("(max-width: 991px)").matches;

  if (isMobile && !init) {
    init = true;
    
    // Initialize Features Swiper
    featuresSwiper = new Swiper("#featuresPricingTableSlider", {
      slidesPerView: "auto",
      spaceBetween: 5,
      grabCursor: true,
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: "#navBtnRightFeatures",
        prevEl: "#navBtnLeftFeatures",
      },
      on: {
        slideChange: updateNavigationStateFeatures,
        init: updateNavigationStateFeatures,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
      },
    });

    // Initialize Services Swiper
    servicesSwiper = new Swiper("#servicesPricingTableSlider", {
      slidesPerView: "auto",
      spaceBetween: 5,
      grabCursor: true,
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: "#navBtnRightServices",
        prevEl: "#navBtnLeftServices",
      },
      on: {
        slideChange: updateNavigationStateServices,
        init: updateNavigationStateServices,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
      },
    });
  } else if (!isMobile && init) {
    if (featuresSwiper) {
      featuresSwiper.destroy(true, true);
      featuresSwiper = null;
    }
    if (servicesSwiper) {
      servicesSwiper.destroy(true, true);
      servicesSwiper = null;
    }
    init = false;
  }
}

onMounted(async () => {
  await nextTick();
  mediaQuery = window.matchMedia("(max-width: 991px)");
  initSwipers();
  mediaQuery.addEventListener("change", initSwipers);
});

onBeforeUnmount(() => {
  if (mediaQuery) {
    mediaQuery.removeEventListener("change", initSwipers);
  }
  if (featuresSwiper) {
    featuresSwiper.destroy(true, true);
  }
  if (servicesSwiper) {
    servicesSwiper.destroy(true, true);
  }
});

// Track if monthly is selected
const isMonthly = ref(true)

const setMonthly = (value: boolean) => {
  isMonthly.value = value
}

const toggleView = () => {
  isMonthly.value = !isMonthly.value
}

</script>

<style scoped>
@import url("~/assets/css/landingStyles.css");

.hide {
  display: none !important;
}

.create-business-card {
  margin-top: 50px;
}

.landing_wrapper .hero .section_title h1 {
  min-height: auto !important;
}
</style>
